import React from "react";
import { Field } from "react-final-form";
import { TextInput } from "../../../components/inputs/final_form/TextInput";
import { adminApi as api } from "../../../util/api";
import { snakifyKeys } from "../../../util/helpers";
import { required } from "../../../util/validators";
import { ImportModal } from "../../components/ImportModal";

const RESOURCE_TYPE_LAB = "Lab";
const RESOURCE_TYPE_CLINIC = "Clinic";

export const ImportReportDeliveriesModal = ({ onImport, resourceId, resourceType, ...rest }) => {
  const resourceKey = `${resourceType}Id`;

  const handleImport = async (values) => {
    const params = {
      [resourceKey]: resourceId,
      file: {
        bytes: values.file,
      },
    };

    const res = await api.post(`/admin/report_delivery_configs/import.json`, snakifyKeys(params));

    if (onImport) {
      onImport(res.data?.meta?.message);
    }
  };

  const modalTitle = `Add Report Delivery Config to ${resourceType == "lab" ? RESOURCE_TYPE_LAB : RESOURCE_TYPE_CLINIC} from CSV...`;

  return (
    <ImportModal
      buttonProps={rest}
      onImport={handleImport}
      title={modalTitle}
      exampleDownloadPath={`/admin/report_delivery_configs/example?report_delivery_config[resource_type]=${resourceType}`}
    />
  );
};
